import React from 'react';
import { GitBranch, RefreshCw, X } from 'lucide-react';
import VersionHistory from '../VersionHistory';

const VersionHistorySidebar = ({
  showVersionsDropdown,
  setShowVersionsDropdown,
  versionHistoryRef,
  surveyId,
  setScreens,
  setDeviceMode,
  setCurrentScreenIndex,
  setSelectedElement,
  clearHistory,
  runWithoutUndo,
  saveRestoredVersion,
}) => {
  if (!showVersionsDropdown) return null;

  const handleRestoreVersion = async (restoredVersion) => {
    if (restoredVersion?.configuration?.screens) {
      const nextScreens = restoredVersion.configuration.screens;
      const nextDeviceMode = restoredVersion.configuration.deviceMode;
      clearHistory?.();
      const apply = () => {
        setScreens(nextScreens);
        if (nextDeviceMode) {
          setDeviceMode(nextDeviceMode);
        }
        if (typeof setCurrentScreenIndex === 'function') {
          setCurrentScreenIndex((idx) =>
            Math.min(idx, Math.max(0, nextScreens.length - 1))
          );
        }
        setSelectedElement?.(null);
      };
      if (typeof runWithoutUndo === 'function') {
        runWithoutUndo(apply);
      } else {
        apply();
      }
      setShowVersionsDropdown(false);
      // Persist the restored snapshot to the live assessment. Loading it into
      // the canvas alone leaves it unsaved (and lost on navigation); pushing it
      // through save-screens makes the restore durable. Pass the restored
      // screens explicitly so we don't depend on the just-queued state update.
      if (typeof saveRestoredVersion === 'function') {
        await saveRestoredVersion(nextScreens, nextDeviceMode);
      }
    }
  };

  const handleRefresh = () => {
    if (versionHistoryRef.current?.refresh) {
      versionHistoryRef.current.refresh();
    }
  };

  return (
    <div className="w-96 bg-white dark:bg-gray-900 border-l border-gray-200/80 dark:border-white/[0.06] flex flex-col shadow-float z-30">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200/80 dark:border-white/[0.06]">
        <h3 className="text-[15px] font-semibold text-gray-900 dark:text-gray-50 flex items-center gap-2">
          <GitBranch className="w-4 h-4 text-gray-400 dark:text-gray-500" strokeWidth={1.75} />
          Version History
        </h3>
        <div className="flex items-center gap-1">
          <button
            onClick={handleRefresh}
            className="btn btn-ghost btn-sm btn-icon"
            title="Refresh versions"
          >
            <RefreshCw className="w-4 h-4" />
          </button>
          <button
            onClick={() => setShowVersionsDropdown(false)}
            className="btn btn-ghost btn-sm btn-icon"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        <VersionHistory
          ref={versionHistoryRef}
          surveyId={surveyId}
          currentVersion={null}
          onRestoreVersion={handleRestoreVersion}
        />
      </div>
    </div>
  );
};

export default VersionHistorySidebar;
